import { render, staticRenderFns } from "./custom-toggle-switcher.vue?vue&type=template&id=1fb6da8c&"
import script from "./custom-toggle-switcher.vue?vue&type=script&lang=ts&"
export * from "./custom-toggle-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./custom-toggle-switcher.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports